@if (loader) {
<app-loader></app-loader>
}

<div class="flex justify-content-between align-items-center mt-3">
    <div>
        <p-button label="Add" icon="pi pi-plus-circle" size="small" (onClick)="addVendorBank()"></p-button>

        <p-button (onClick)="deleteVendorBank()" [disabled]="selected && selected.length == 0" label="Remove"
            class="p-button-outlined ml-2 " icon="pi pi-trash" severity="danger" size="small"></p-button>

        <p-button label="Edit" class="ml-2" icon="pi pi-user-edit" size="small" severity="secondary"
            [disabled]="!selected || selected.length !== 1" (click)="editSelectedBank()">
        </p-button>


    </div>

    <div class="flex">
        <div class="flex align-items-center">
            <p-button icon="pi pi-refresh" size="small" (onClick)="refreshData()" [rounded]="true"
                severity="info"></p-button>
        </div>
    </div>

</div><br>

<p-table #dt1 class="mt-3" [value]="list" dataKey="vendorBankAccountId" selectionMode="multiple"
    [(selection)]="selected" [rows]="10" [paginator]="true" [rowsPerPageOptions]="[10,20,30]" 
    [paginatorDropdownAppendTo]="'body'" [scrollable]="true" scrollHeight="400px" responsiveLayout="scroll">

    <ng-template pTemplate="header">
        <tr>
            <th><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
            <th>Account Holder Name</th>
            <th>Bank Name</th>
            <th>Account Number</th>
            <th>IFSC</th>
            <th>IsPrimary</th>  
        </tr>
    </ng-template>

    <ng-template pTemplate="body" let-row>
        <tr>
            <td> <p-tableCheckbox [value]="row"></p-tableCheckbox> </td>
            <td>
                <a class="text-blue-500 underline cursor-pointer" (click)="editBank(row)">
                    {{ row.accountHolderName }}
                </a>
            </td>

            <td>{{ row.bankName }}</td>
            <td>{{ row.accountNumber }}</td>
            <td>{{ row.ifsc }}</td>
            <td>
                <i class="pi" [ngClass]="row.isPrimary ? 'pi-star-fill text-yellow-500' : 'pi-star text-gray-400'"
                    style="cursor:pointer" pTooltip="Set as Primary" (click)="setPrimary(row)">
                </i>
            </td>

        </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="5" class="text-center">No records found</td>
        </tr>
    </ng-template>

</p-table>


<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>
